export default __webpack_public_path__ + "static/media/logo-colored.453e916d.png";